import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { acceptJson } from '../shared.js';
import { placeDetailsResponseSpec } from './specs.js';

const getPlaceDetails = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return validateResponse(placeDetailsResponseSpec, (yield fetch(`${apiUrl}/place/details?place_id=${request.id}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function getPlaceDetails(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getPlaceDetails };
//# sourceMappingURL=place-details.js.map
